import React from 'react';
import Badge from '../../common/Badge';

// Helper function to format dates
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (e) {
    return 'Invalid Date';
  }
};

// Helper function to format email domain
const formatEmailDomain = (email) => {
  if (!email) return 'N/A';
  const parts = email.split('@');
  return parts.length > 1 ? parts[1] : email;
};

/**
 * Creates the column definitions for the Lead List table
 * @param {Object} handlers - Object containing handler functions
 * @param {Function} handlers.onView - Handler for view action
 * @param {Function} handlers.onEdit - Handler for edit action
 * @returns {Array} Array of column definitions
 */
export const createLeadColumns = ({ onView, onEdit }) => [
  {
    key: 'name',
    header: 'Name',
    render: (value, row) => (
      <div className="lead-list__name-cell">
        <strong>
          {row.first_name || ''} {row.last_name || ''}
        </strong>
        {row.company_name && (
          <span className="lead-list__company-name">
            {row.company_name}
          </span>
        )}
      </div>
    ),
  },
  {
    key: 'email',
    header: 'Email',
    render: (value, row) => (
      <div className="lead-list__email-cell">
        <a href={`mailto:${row.email}`} className="lead-list__email-link">
          {row.email}
        </a>
        {row.email_domain && (
          <span className="lead-list__email-domain">
            @{row.email_domain}
          </span>
        )}
      </div>
    ),
  },
  {
    key: 'job_title',
    header: 'Job Title',
    render: (value, row) => row.job_title || <span className="lead-list__empty">—</span>,
  },
  {
    key: 'country',
    header: 'Location',
    render: (value, row) => (
      <div>
        {row.country || <span className="lead-list__empty">—</span>}
        {row.region_state && (
          <span className="lead-list__region">, {row.region_state}</span>
        )}
      </div>
    ),
  },
  {
    key: 'phone',
    header: 'Phone',
    render: (value, row) => row.phone || <span className="lead-list__empty">—</span>,
  },
  {
    key: 'consent_given',
    header: 'Consent',
    render: (value, row) => (
      <Badge variant={row.consent_given ? 'success' : 'warning'} size="small">
        {row.consent_given ? 'Yes' : 'No'}
      </Badge>
    ),
  },
  {
    key: 'download_count',
    header: 'Downloads',
    render: (value, row) => (
      <span className="lead-list__download-count">
        {row.download_count || 0}
      </span>
    ),
  },
  {
    key: 'created_at',
    header: 'Created',
    render: (value, row) => formatDate(row.created_at),
  },
  {
    key: 'actions',
    header: 'Actions',
    render: (value, row) => (
      <div className="lead-list__actions">
        <button
          className="lead-list__btn lead-list__btn--view"
          onClick={(e) => {
            e.stopPropagation();
            onView(row);
          }}
          title="View Details"
        >
          View
        </button>
        <button
          className="lead-list__btn lead-list__btn--edit"
          onClick={(e) => {
            e.stopPropagation();
            onEdit(row);
          }}
          title="Edit"
        >
          Edit
        </button>
      </div>
    ),
  },
];











